/**
 * The ⓘ beside an analysis's name: hovering shows the client's own
 * description of the rule, each numbered item ("1. …", "2. …") on its own
 * line.
 */

import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/** "1. A. 2. B." -> ["1. A.", "2. B."]; text with no numbering stays whole. */
export function descriptionLines(description: string): string[] {
	return description
		.split(/\s+(?=\d+\.\s)/)
		.map((line) => line.trim())
		.filter(Boolean);
}

export function AnalysisInfo({ description }: { description: string }) {
	if (!description) return null;
	return (
		<Tooltip
			arrow
			placement="right"
			title={
				<Box className="stack2">
					{descriptionLines(description).map((line) => (
						<Box key={line}>{line}</Box>
					))}
				</Box>
			}
		>
			<InfoOutlinedIcon
				fontSize="inherit"
				aria-label="About this analysis"
				tabIndex={0}
				onClick={(event) => event.stopPropagation()}
				sx={{
					ml: 0.5,
					verticalAlign: 'middle',
					cursor: 'help',
					color: 'text.secondary',
				}}
			/>
		</Tooltip>
	);
}
